<template>
  <div class="app-container">
    <div class="report-page">
      <div class="box-card card-right">
        <div class="box-card-head">
          我的任务
        </div>
        <div class="box-card-body">
          <div class="right-body-head">
              <dynamic-form
                labelWidth="110px"
                :formConfig="formConfigHead"
                v-model="form"
                :showBtn="false"
              />
          </div>
          <edit-data-table
            ref="tableList"
            :showNumber="false"
            :editable="true"
            :loading="loading"
            :head="tableHead"
            :config="{ trigger: 'click', mode: 'cell', autoClearActive: false }"
            :border="false"
            :data.sync="tableData"
            :toolBar="{ hidden: true }"
          >
            <template v-for="(value, key) in daysMap" v-slot:[key]="scope">
              <edit-data-table
                :key="key"
                :showNumber="false"
                :editable="true"
                :showHeader="false"
                :head="innerTableHead"
                :config="{
                  trigger: 'click',
                  mode: 'cell',
                  autoClearActive: false,
                }"
                height=""
                :border="false"
                :data.sync="tableData[scope.$index][key]"
                :showAdd="false"
                :toolBar="{ label: '操作', width: 100 }"
                :row-style="tableRowClassName"
              >
                <template #toolbar="{ row, $index }">
                  <!-- 查看-->
                  <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-view"
                    v-if="canView(row, value)"
                    @click="view(row, $index)"
                  ></el-button>
                  <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-circle-close"
                    v-if="showBtn(row, value)"
                    @click="refuseTask(row)"
                  ></el-button>
                  <!-- 汇报-->
                  <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-edit-outline"
                    v-if="canReport(row, value)"
                    @click="report(row, $index)"
                    >汇报</el-button
                  >
                  <!-- 汇报修改-->
                  <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-edit"
                    v-if="reportUpde(row)"
                    @click="reportDetail(row, $index)"
                    >修改</el-button
                  >
                  <!-- 转交-->
<!--                  <el-button-->
<!--                    type="text"-->
<!--                    size="mini"-->
<!--                    icon="el-icon-top-right"-->
<!--                    v-if="timeUp(row, value)"-->
<!--                    @click="decompositions(row, value)"-->
<!--                  ></el-button>-->
                  <span
                    type="warning"
                    v-if="row.taskState === 'C'"
                    class="z-btn"
                    >已转交</span
                  >
                  <!-- 确认任务-->
                  <!-- <el-button type="text" size="mini" icon="el-icon-thumb" @click="taskComfirm(row,value)"></el-button> -->
                  <el-popover
                    :ref="$index + 'a'"
                    placement="top"
                    width="220"
                    v-if="row.whetherCan && row.taskState === 'D'"
                  >
                    <p>确定审批通过该任务吗？</p>
                    <div style="text-align: right; margin: 0">
                      <el-button
                        size="mini"
                        type="text"
                        @click="cancel2($index + 'a')"
                        >取消</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="taskComfirm(row, 'T', $index + 'a')"
                        >退回</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="taskComfirm(row, 'N')"
                        >确定</el-button
                      >
                    </div>
                    <el-button
                      type="text"
                      size="mini"
                      icon="el-icon-circle-check"
                      slot="reference"
                    ></el-button>
                  </el-popover>
                </template>
              </edit-data-table>
            </template>
          </edit-data-table>
        </div>
      </div>
    </div>
    <!-- 查看任务-->
    <drag-dialog
      append-to-body
      :show.sync="dialogVisible2"
      title="任务汇报"
      :enableDrag="true"
      width="800px"
      @close="cancel"
    >
      <dynamic-form
        :formConfig="formConfig"
        v-model="form"
        :showBtn="false"
        labelWidth="120px"
        @submit="submit"
        @cancelForm="cancel"
        ref="pageForm"
      ></dynamic-form>
    </drag-dialog>
    <drag-dialog
      append-to-body
      :show.sync="dialogVisible"
      title="任务汇报"
      :enableDrag="true"
      width="800px"
      @close="cancel"
    >
      <dynamic-form
        :formConfig="formConfig"
        v-model="form"
        labelWidth="120px"
        @submit="submit"
        @cancelForm="cancel"
        ref="pageForm"
      ></dynamic-form>
    </drag-dialog>
    <!-- 延期转交 -->
    <drag-dialog
      append-to-body
      :show.sync="taskof"
      title="任务转交"
      :enableDrag="true"
      width="600px"
      @close="taskofCancel"
    >
      <dynamic-form
        :formConfig="taskofConfig"
        v-model="taskofForm"
        labelWidth="120px"
        @submit="taskSubmit"
        @cancelForm="taskofCancel"
        ref="pageForm"
      ></dynamic-form>
    </drag-dialog>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DataTableMixin from "@/mixins/DataTableMixin";
import "@/components/dynamic-form";
import { parseTime } from "@/utils";
import DragDialog from "@/components/DragDialog";
import { getTaskReport, TaskReport, TaskReportDetail, TaskReportUpdate, taskcareSubmit, taskCareOfApply } from "@/api/bill/taskReport";
import { mapGetters } from 'vuex'
import { update } from '@/api/bill/assignment'
import { deepClone } from '../../../components/edit-table/src/util';
import { nextTick } from "process";
import { taskRefuse } from '@/api/bill/assignment'

export default {
  name: "Assignment",
  mixins: [DataTableMixin],
  components: { DragDialog },
  computed: { ...mapGetters(['user']) },
  data () {
    return {
      formConfig: {
        formItemList: [
          {
            span: 12,
            label: "节点编号",
            key: "taskNodeNumber",
            type: "input",
            disabled: true
          },
          {
            span: 12,
            label: "任务名称",
            key: "name",
            type: "input",
            disabled: true
          },
          {
            span: 12,
            label: "任务剩余人天",
            key: "taskDayDiff",
            type: "text",
            disabled: true
          },
          {
            span: 12,
            label: "汇报时间",
            key: "workAlloctionTime",
            type: "date",
            disabled: true,
          },
          {
            span: 12,
            label: "任务分配内容",
            key: "content",
            type: "textarea",
            disabled: true
          },
          {
            span: 12,
            label: "汇报内容",
            key: "workReport",
            type: "textarea",
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
            disabled: false
          },
          {
            span: 12,
            label: "是否完成",
            key: "accomplishCondition",
            type: "switch",
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
            disabled: false
          },
          {
            span: 12,
            label: "实际完成人天",
            key: "actualHumanNature",
            type: 'input',
            subtype: 'number',
            disabled: false,
            rules: [{ required: true, message: "不能为空", trigger: "blur"
            }],
          },
          {
            span: 12,
            label: "确认人天",
            key: "confirmDays",
            type: 'input',
            subtype: 'number',
            disabled: true,
          }
        ]
      },
      taskofConfig: {
        formItemList: [
          {
            label: '任务接收人',
            key: 'taskReceivers',
            type: 'databox',
            span: 24,
            props: {
              label: 'personName',
              value: 'personId'
            },
            url: '/bizTaskDecomposition/getDisposablePerson',
            tableColumn: [
              {
                property: "code",
                label: "编码",
                query: {
                  type: 'input'
                }
              },
              {
                property: "personName",
                label: "名称",
                query: {
                  type: 'input'
                }
              }
            ],
            extendParms: { queryFieldItem: 'personId,name' },
            multiple: false,
            rules: [
              {
                required: true, message: '不能为空', trigger: 'change'
              },
            ]
          },
          {
            span: 24,
            type: "input",
            key: "taskContent",
            label: "任务内容",
            subtype: 'textarea',
            placeholder: "请输入任务内容",
            rules: [
              {
                required: true, message: '不能为空', trigger: 'blur'
              },
            ]
          },
          {
            span: 24,
            label: '计划开始日期',
            key: 'plannedStartTime',
            type: 'date',
            rules: [
              {
                required: true, message: '不能为空', trigger: 'blur'
              },
            ]
          },
          {
            span: 24,
            label: '计划完成日期',
            key: 'plannedEndTime',
            type: 'date',
            rules: [
              {
                required: true, message: '不能为空', trigger: 'blur'
              },
            ]
          },
          {
            span: 24,
            label: '可支配人天',
            key: 'disposableHumanNature',
            type: 'input',
            subtype: 'number',
            rules: [
              {
                pattern: "^([0-9][0-9]{0,1}|)+\.?[0-9]{0,1}$",
                message: "请输入正确人天(保留1位小数)",
                trigger: "blur"
              },
              {
                required: true, message: '不能为空', trigger: 'blur'
              },
            ]
          },
        ],
      },
      formConfigHead: {
        formItemList: [
          {
            type: "databox",
            key: "project",
            label: "项目号",
            placeholder: "请选择项目",
            value: "",
            span: 6,
            props: {
              label: "code",
              value: ""
            },
            url: "/home/findProject",
            tableColumn: [
              {
                property: "code",
                label: "项目号",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "项目名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            span: 6,
            label: '选择月',
            key: 'time',
            type: 'date',
            subtype: 'month',
            valueFormat: 'yyyy-MM',
            clearable: false
          },
        ]
      },
      form: { projectNum: '', jobContentId: '', id: '' },
      reportform: {},
      taskofForm: {},
      innerTableHead: [
        { label: "任务编号", prop: "taskNodeCode", width: '90' },
        { label: "任务内容", prop: "content" }
        // { label: "计划完成日期", prop: "expectedEndTime" }
      ],
      dialogVisible: false,
      taskof: false,
      tableHead: [
        {
          label: "项目成员/日期",
          prop: "personName",
          width: 120,
          fixed: 'left'
        },
        {
          label: '第一周',
          prop: 'week1',
          align: 'center',
        },
      ],
      tableData: [],
      daysMap: {},
      reportedIdList: [],  // 已汇报过的任务id数组（全部）
      reportedIdSuccessList: [],
      projectCode: '',
      viewFlag: true,
      dialogVisible2: false,
      currentWeek: "" // 当前周
    };
  },
  created () {
    this.initTime();
    nextTick(() => {
      const code = this.$route.query.projectCode
      if (code) {
        console.log('123456', code)
        this.form.project = { code: code }
        // this.$set(this.formConfigHead.formItemList[this.formConfigHead.formItemList.findIndex(i => i.key === 'project')], 'value', code)
      }
    })
  },
  watch: {
    "form.project": {
      handler (val, oldVal) {
        if (val && val !== oldVal) {
          console.log(val)
          this.projectNumber = val.code
          this.getList(this.projectNumber, parseTime(this.form.time,"{y}-{m}"))
        }
      },
      deep: false
    },
    "form.time": {
      handler (val, oldVal) {
        if (val !== oldVal && this.form.project.code) {
          if (this.projectNumber) {
            this.getList(this.projectNumber,parseTime(this.form.time,"{y}-{m}"))
          }
        }
      },
      deep: false
    }
  },
  methods: {
    // 测试
    refuseTask (row) {
      const params = {
        id: row.jobContentId,
        reportId: row.id
      }
      this.$confirm('是否回退?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        taskRefuse(params).then(res => {
          if (res.code === 200) {
            this.getList(this.projectNumber,parseTime(this.form.time,"{y}-{m}"))
            this.$notify({ title: '汇报回退成功！', type: 'success', duration: 2500 })
          }
        })
      })
    },
    cancel2(id) {
      this.$refs[id][0].doClose()
    },
    // 获取表格数据
    getList(projectCode,month) {
      if (this.loading) {
        return
      }
      this.loading = true;
      this.tableData = [];
      this.reportedIdList = [];
      this.reportedIdSuccessList = [];
      getTaskReport({projectCode, month: month}).then(res => {
        this.loading = false;
        if (res.data.tableHead.length && this.tableHead instanceof Array) {
          this.tableHead = res.data.tableHead
          // 塞二级表格
          this.daysMap = res.data.tableHead.reduce((accumulator, cur,index) => {
            if (index !== 0) {
              accumulator[cur.prop] = cur
            }
            return accumulator
          }, {});
        }
        const whetherCan = res.data.whetherCan // 角色权限 true有权限操作 false 无
        const currentWeek = res.data.currentWeek // 角色权限 true有权限操作 false 无
        this.currentWeek = currentWeek
        res.data.homeList.forEach(async item => {
          const project = { personName: item.personName,personId: item.personId,week1: [],week2: [],week3: [],week4: [],week5: [],week6: [] };
          item.bizJobContentDecompositions.forEach(sub => {  // 任务明细
            project[sub.taskWeek].push({
              // taskContent: sub.taskContent,
              content: sub.taskContent,
              taskNodeCode: sub.taskNodeCode,
              projectNode: sub.projectNode,
              taskFlag: 1,  // 1 任务内容，2 汇报明细，3 延期任务
              projectCode: sub.projectCode,
              id: sub.id,
              releaseStatus: sub.releaseStatus,
              personName: item.personName,
              personId: item.personId,
              taskState: sub.taskState, // 延期判断
              taskType: sub.taskType, // 任务类型
              plannedEndTime: sub.plannedEndTime,
              plannedStartTime: sub.plannedStartTime,
              disposableHumanNature: parseFloat(sub.disposableHumanNature).toFixed(1), // 可支配人天
              whetherCan,
              taskWeek: sub.taskWeek,
              name: sub.name ? sub.name : '',
              taskDayDiff: sub.taskDayDiff,
              verifyHumanNature: sub.verifyHumanNature
            });
          });

          for (const later of item.laterList) {  // 延期任务
            const now =  new Date(parseTime(new Date(),'{y}-{m}-{d}')).getTime()
            const stTime = this.getEndDate(parseTime(new Date(later.plannedEndTime),'{y}-{m}-{d}'), parseTime(new Date(),'{y}-{m}-{d}'))
            project[currentWeek].push({
                  // taskContent: later.taskContent,
                  content: later.taskContent,
                  taskNodeCode: later.taskNodeCode,
                  taskFlag: stTime >= 7 ? 7 : new Date(parseTime(new Date(later.plannedEndTime),'{y}-{m}-{d}')).getTime() < now ? 3 : 1,
                  projectCode: later.projectCode,
                  id: later.id,
                  personName: item.personName,
                  personId: item.personId,
                  taskState: later.taskState, // 延期判断
                  taskType: later.taskType,
                  whetherCan,
                  taskWeek: currentWeek,
                  name: later.name ? later.name : '',
                  taskDayDiff: later.taskDayDiff,
                  verifyHumanNature: later.verifyHumanNature
              });
          }

          for (const reportItem of item.bizTaskReports) { // 汇报明细
             if (reportItem.taskWeek === currentWeek) {
               this.reportedIdList.push(reportItem.jobContentId)  // 添加今天已汇报的任务id(全部)
             }
              if (reportItem.accomplishCondition === 'Y') {
                this.reportedIdSuccessList.push(reportItem.jobContentId);
              }
              project[reportItem.taskWeek].push({
              taskContent: reportItem.workReport,
              content: reportItem.taskContent,
              taskNodeCode: reportItem.taskNodeNumber,
              taskFlag: 2,
              id: reportItem.id,
              actualHumanNature: reportItem.actualHumanNature,
              workAlloctionTime: reportItem.workAlloctionTime,
              accomplish: reportItem.accomplishCondition,
              personName: item.personName,
                personId: item.personId,
              taskState: reportItem.accomplishCondition, // 延期判断
              taskType: reportItem.taskType, // 任务类型
              confirmDays: reportItem.confirmDays,
              whetherCan,
              taskWeek: reportItem.taskWeek,
              disposableHumanNature: reportItem.disposableHumanNature ? parseFloat(reportItem.disposableHumanNature).toFixed(1) : 0 , // 可支配人天
              name: reportItem.name ? reportItem.name : '',
              taskDayDiff: reportItem.taskDayDiff,
              jobContentId: reportItem.jobContentId,
              verifyStatus: reportItem.verifyStatus,
              verifyHumanNature: reportItem.verifyHumanNature
            });
          }
          this.tableData.push(project);
        });
        this.$nextTick(() => {
          const date = new Date()
          let w = date.getDay()
          const d = date.getDate()
          if (w === 0) {
            w = 7
          }
          const week = Math.ceil((d + 6 - w) / 7) // 获取当前日期在本月第几周
          // console.log(week, res.data.tableHead[1])
          const minWidth = res.data.tableHead[1].minWidth
          console.log(this.$refs.tableList.$refs.elTable.$refs.refElTable.bodyWrapper)
          setTimeout(() => {
            this.$refs.tableList.$refs.elTable.$refs.refElTable.bodyWrapper.scrollLeft = (Number(week) - 1) * Number(minWidth)
          }, 500) // 必须是1000以上 才能生效
        })
      }).catch(() => {
        this.loading = false;
      });
    },
    // 确认任务
    taskComfirm(row,status,id) {
      row.taskState = status
      row.plannedEndTime = new Date(row.plannedEndTime).getTime();
      row.plannedStartTime = new Date(row.plannedStartTime).getTime();
      update(row).then(res => {
        if (res.code === 200 && res.data) {
          row.taskState = status
          this.$refs[id][0].doClose()
        }
        // const startTime = this.tableHead[1].label.slice(3,13)
        // this.getList(this.projectNumber,startTime);
      })
    },
    /**
     * 时间差
     */
    getEndDate(date1,date2) {
      // var date1= '2018-11-30 11:39:10';  //开始时间
      // var date2 = new Date();    //结束时间
      const date3 = new Date(date2).getTime() - new Date(date1).getTime() // 时间差的毫秒数
      // 计算出相差天数
      let  days = Math.floor(date3 / (24 * 3600 * 1000))
       days = Math.abs(days)
      return days
    },
    /**
     * 延期转交详情
     */
    decompositions(row,value) {
      taskCareOfApply({projectCode: this.projectNumber}).then(res => {
        const obj = {projectCode: row.projectCode,startTime: parseTime(new Date(),'{y}-{m}-{d}')}
        this.$set(this.taskofConfig.formItemList[0],"extendParms",obj)
        this.taskof = true
        this.taskofForm = row
        this.taskofForm.plannedStartTime = value.begin
        this.taskofForm.plannedEndTime = value.end
        this.taskofForm.originalTask = row.id
      })
    },
    /**
     * 延期转交提交
     */
    taskSubmit() {
      if (this.taskofForm.parentId === this.taskofForm.taskReceivers.parentId) {
        return this.$notify({title: '不能转交给同一个人！', type: 'error', duration: 2500})
      }
      this.taskofForm.plannedEndTime = new Date(this.taskofForm.plannedEndTime).getTime()
      this.taskofForm.plannedStartTime = new Date(this.taskofForm.plannedStartTime).getTime()
      if (this.taskofForm.plannedEndTime < this.taskofForm.plannedStartTime) {
        this.$notify({
          title: '结束时间不能小于开始时间',
          type: 'warning',
          duration: 2500
        })
        return
      }
      this.taskofForm.taskReceiver = this.taskofForm.taskReceivers.personId
      this.taskofForm.id = ''
      taskcareSubmit(this.taskofForm).then(res => {
        this.taskof = false;
        this.$notify({
          title: '转交成功',
          type: 'success',
          duration: 2500
        })
        this.getList(this.projectNumber,parseTime(this.form.time,"{y}-{m}"));
      })
    },
    // 初始化时间
    initTime() {
      if (!this.form.time) {
        this.form.time =  new Date()
      }
    },
    // 样式绑定
    tableRowClassName(row) {
      if (row.row.taskFlag === 1) {
        return 'background: #ffffff'
      } else if (row.row.taskFlag === 2) {
        if (row.row.accomplish === 'Y') {
          return 'background: #d9ecd9;color:#008000'
        }
         return 'background: #fff5d9;color:#ffba00'
      } else {
         // 判断延期时间是否大于等于7天,需要根据时间判断，还没有计算
        //  if (row.row.taskFlag >= 7) {
        //    return 'background: #ffcccc;color:#ff0000'
        //  }
        //  return 'background: #c7e6fc;color:#1369a8'

        return 'background: #ffcccc;color:#ff0000'
      }
    },
    // 查看汇报按钮条件
    canView(row,value) {
      // if (row.taskState === 'Y') {
        this.viewFlag = false
        return true
      // } else {
      //    this.viewFlag = true
      //    return false
      // }
    },
    // 查看汇报内容
    view(row) {
      this.form.jobContentId  = row.id;
      this.form.name = row.name
      this.dialogVisible2 = true;
      this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(i => i.key === 'workReport')],'disabled',true)
      this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(i => i.key === 'accomplishCondition')],'disabled',true)
      this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(i => i.key === 'actualHumanNature')],'disabled',true)
      this.form.projectNum = row.projectCode;
      this.form.taskNodeNumber = row.taskNodeCode;
      this.form.workReport = row.taskContent
      console.log("查看汇报内容");
      this.form.content = row.content
      this.form.workAlloctionTime = new Date(row.plannedEndTime || row.workAlloctionTime)
      this.form.actualHumanNature = row.disposableHumanNature || row.actualHumanNature
      this.form.confirmDays = row.confirmDays
      this.form.taskDayDiff = row.taskDayDiff // 赋值剩余人天
      // this.form.accomplishCondition = row.taskState === 'Y' ? true: false;
      if (row.taskState === 'Y') {
        this.form.accomplishCondition =  true
      } else {
        this.form.accomplishCondition = false
      }
    },
    // 汇报弹窗
    report(row) {
      this.form.jobContentId  = row.id;
      this.form.confirmDays = '';
      this.form.name = row.name
      this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(i => i.key === 'workReport')],'disabled',false)
      this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(i => i.key === 'accomplishCondition')],'disabled',false)
      this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(i => i.key === 'actualHumanNature')],'disabled',false)
      this.form.projectNum = row.projectCode;
      this.form.content = row.content
      this.form.taskNodeNumber = row.taskNodeCode;
      this.form.code = '';
      this.form.id = '';
      this.form.workReport = '';
      this.form.workAlloctionTime = new  Date();
      this.form.accomplishCondition = false;
      this.form.taskDayDiff = row.taskDayDiff // 赋值剩余人天
      // this.form.actualHumanNature = 11
      // this.$set(this.formConfig.formItemList[5],'value',10)
      this.dialogVisible = true;
    },
    // 汇报详情
    reportDetail(row) {
      TaskReportDetail(row.id).then(res => {
        this.dialogVisible = true;
        this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(i => i.key === 'workReport')],'disabled',false)
        this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(i => i.key === 'accomplishCondition')],'disabled',false)
        this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(i => i.key === 'actualHumanNature')],'disabled',false)
        this.form.jobContentId  = res.data.jobContentId;
         this.form.taskNodeNumber = res.data.taskNodeNumber;
         this.form.projectNum  = res.data.projectNum;
         this.form.workReport = res.data.workReport;
         this.form.content = row.content
         this.form.workAlloctionTime = res.data.workAlloctionTime;
         this.form.id = res.data.id;
         this.form.actualHumanNature = res.data.actualHumanNature
         if (res.data.accomplishCondition === 'Y') {
           this.form.accomplishCondition = true
         } else {
           this.form.accomplishCondition = false
         }
          // this.form.accomplishCondition = res.data.accomplishCondition =='true' ? true : false;
      })
    },
    cancel() {
      this.dialogVisible = false;
    },
    taskofCancel() {
      this.taskof = false
    },
    submit() {
      const form = deepClone(this.form)
      form.workAlloctionTime = new Date(this.form.workAlloctionTime).getTime()
      form.accomplishCondition = form.accomplishCondition ? 'Y' : 'N'
      if (parseFloat(form.actualHumanNature) > parseFloat(form.taskDayDiff)) {
        this.$confirm('本次汇报已超出任务剩余人天，确认提交?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         this.saveForm(form)
        })
      } else if (parseFloat(form.actualHumanNature) === parseFloat(form.taskDayDiff) && form.accomplishCondition === 'N') {
        this.$confirm('请注意勾选任务是否完成?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.saveForm(form)
        })
      } else {
        this.saveForm(form)
      }
    },
    saveForm(form) {
      if (form.id) {
        TaskReportUpdate(form).then(res => {
          if (res.code === 200) {
            this.dialogVisible = false;
            this.$notify({ title: '汇报成功！',type: 'success', duration: 2500 })
            this.getList(this.projectNumber,parseTime(this.form.time,"{y}-{m}"));
          }
      })
      } else {
       TaskReport(form).then(res => {
        if (res.code === 200) {
          this.dialogVisible = false;
          this.$notify({ title: '汇报成功！',type: 'success', duration: 2500 })
          this.getList(this.projectNumber,parseTime(this.form.time,"{y}-{m}"));
        }
      })
      }
    },
     // 转交限制
    timeUp(row,value) {
      if (row.whetherCan && this.currentWeek === value.prop && row.taskState === 'N' && [1,3,7].includes(row.taskFlag)) {
        return true
      } else {
        return false
      }
    },
    // 撤回权限
    showBtn(row, value) {
      if (!row.jobContentId) { // 是否已汇报
        return false
      }
      if (row.personId !== this.user.personId) { // 校验当前用户
        return false;
      }
      if (this.currentWeek !== value.prop) { // 当前周
        return false
      }
      if (row.verifyStatus === 1) { // 项目经理是否确认
        return false
      }
      if (row.taskState === 'Y') { // 是否完成
        return true;
      }
      return false;
    },
    // 禁用汇报功能条件
    canReport(row, value) {
      // 已经完成、未审批、退回的任务没有汇报权限
      if (row.taskState === 'Y' || row.taskState === 'C' || row.taskState === 'D' || row.taskState === 'T') {
        return false
      }
      // 意见确认完成
      if (row.verifyStatus === 1) {
        return false
      }
      if (this.currentWeek !== value.prop) {
        return false
      } else {
        if (row.personId !== this.user.personId) { // todo
          return false;
        }

        if ([1,3,7].includes(row.taskFlag)) { // 分配的任务内容 或者延期任务 才能汇报
          if (row.releaseStatus === '04') {  // 已经释放不能汇报
            return false
          }
          return !this.reportedIdSuccessList.includes(row.id) && !this.reportedIdList.includes(row.id);
        }
        // 如果当周汇报过，则不能再次汇报，只能走修改逻辑
        if (row.taskWeek === this.currentWeek) {
          return false;
        }
        return true;
      }
    },
    // 修改按钮判断控制
    reportUpde(row, value) {
      if (!row.jobContentId) {
        return false
      }
      if (row.accomplish === 'Y') {
        return false;
      }
      if (row.verifyStatus === 1) {
        // 已确认
        return false
      }
      // 汇报时间是本周 可以修改
      if (row.taskWeek === this.currentWeek) {
        if (row.personId === this.user.personId) {
          return true;
        }
      }
       return false;
    },
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  .report-page {
    .box-card-head {
      border-bottom: 1px solid #1369a8;
      height: 25px;
      color: #1369a8;
    }
    .z-btn{
      background:#fff5d9;
      color:#ffba00;
      border: 1px solid #ffba00;
      padding: 0 6px;
    }
    display: flex;
    // .card-left {
    //   margin-right: 10px;
    //   width: 20%;
    //   .left-body {
    //     padding: 10px 0px;
    //     border-bottom: 1px solid #cccccc;
    //     display: flex;
    //     justify-content: space-between;
    //   }
    // }
    .card-right {
      width: 100%;
      .box-card-body {
        margin: 10px 0;
        .right-body-head {
          margin: 10px 0;
        }
      }
    }
  }
  .box-card {
    background-color: #fff;
    padding: 15px;
    .box-card-head {
      //   width: 50%;
      /deep/.el-col-offset-0 {
        margin-left: -8%;
      }
    }
    /deep/ .el-table {
      padding: 0;
    }
    /deep/.el-table td {
    }
  }
  /deep/ .el-table__empty-block {
    width: auto!important;
  }
}
</style>
